// import React, { useState } from "react";
// import {
//   Button,
//   Card,
//   Col,
//   Container,
//   Form,
//   Row,
//   Table,
// } from "react-bootstrap";
// import Breadcrumb from "Common/BreadCrumb";
// import Flatpickr from "react-flatpickr";
// import Select from "react-select";

// // Import Images
// import logoDark from "assets/images/anjal-gold-logo.png";
// import logoLight from "assets/images/anjal-gold-logo.png";
// import { Link } from "react-router-dom";

// const CreateInvoice = () => {
//   document.title = "Create Invoice | Toner eCommerce + Admin React Template";

//   const [isCurrency, setisCurrency] = useState<any>("$");
//   function handleisCurrency(isCurrency: any) {
//     setisCurrency(isCurrency);
//   }

//   const allcurrency = [
//     {
//       options: [
//         { label: "$", value: "($)" },
//         { label: "£", value: "(£)" },
//         { label: "₹", value: "(₹)" },
//         { label: "€", value: "(€)" },
//       ],
//     },
//   ];

//   return (
//     <React.Fragment>
//       <div className="page-content">
//         <Container fluid={true}>
//           <Breadcrumb title="Create Invoice" pageTitle="Invoices" />

//           <Row className="justify-content-center">
//             <Col xxl={9}>
//               <Card>
//                 <Form className="needs-validation" id="invoice_form">
//                   <Card.Body className="border-bottom border-bottom-dashed p-4">
//                     <Row>
//                       <Col lg={4}>
//                         <div className="profile-user mx-auto  mb-3">
//                           <input
//                             id="profile-img-file-input"
//                             type="file"
//                             className="profile-img-file-input"
//                           />
//                           <label
//                             htmlFor="profile-img-file-input"
//                             className="d-block"
//                           >
//                             <span
//                               className="overflow-hidden border border-dashed d-flex align-items-center justify-content-center rounded"
//                               style={{ height: "150px", width: "256px" }}
//                             >
//                               <img
//                                 src={logoDark}
//                                 className="card-logo card-logo-dark user-profile-image img-fluid"
//                                 alt="logo dark"
//                               />
//                               <img
//                                 src={logoLight}
//                                 className="card-logo card-logo-light user-profile-image img-fluid"
//                                 alt="logo light"
//                               />
//                             </span>
//                           </label>
//                         </div>
//                         <div>
//                           <div>
//                             <Form.Label
//                               htmlFor="companyAddress"
//                               className="form-label"
//                             >
//                               Address
//                             </Form.Label>
//                           </div>
//                           <div className="mb-2">
//                             <textarea
//                               className="form-control"
//                               id="companyAddress"
//                               placeholder="Company Address"
//                               defaultValue=""
//                               rows={3}
//                             />
//                             <div className="invalid-feedback">
//                               Please enter a address
//                             </div>
//                           </div>
//                           <div className="mb-2 mb-lg-0">
//                             <Form.Control
//                               type="text"
//                               id="companyaddpostalcode"
//                               placeholder="Enter Postal Code"
//                               required
//                             />
//                             <div className="invalid-feedback">
//                               The US zip code must contain 5 digits, Ex. 45678
//                             </div>
//                           </div>
//                         </div>
//                       </Col>
//                       <Col lg={4} className="ms-auto">
//                         <div className="mb-2">
//                           <Form.Control
//                             type="text"
//                             id="registrationNumber"
//                             placeholder="Legal Registration No"
//                             required
//                           />
//                           <div className="invalid-feedback">
//                             Please enter a registration no, Ex., 012345678912
//                           </div>
//                         </div>
//                         <div className="mb-2">
//                           <Form.Control
//                             type="email"
//                             id="companyEmail"
//                             placeholder="Email Address"
//                             required
//                           />
//                           <div className="invalid-feedback">
//                             Please enter a valid email, Ex., example@gamil.com
//                           </div>
//                         </div>
//                         <div className="mb-2">
//                           <Form.Control
//                             type="text"
//                             id="companyWebsite"
//                             placeholder="Website"
//                             required
//                           />
//                           <div className="invalid-feedback">
//                             Please enter a website, Ex., www.example.com
//                           </div>
//                         </div>
//                         <div>
//                           <Form.Control
//                             type="number"
//                             data-plugin="cleave-phone"
//                             id="compnayContactno"
//                             placeholder="Contact No"
//                             required
//                           />
//                           <div className="invalid-feedback">
//                             Please enter a contact number
//                           </div>
//                         </div>
//                       </Col>
//                     </Row>
//                   </Card.Body>
//                   <Card.Body className="p-4">
//                     <Row className="g-3">
//                       <Col lg={3} sm={6}>
//                         <Form.Label htmlFor="invoicenoInput">
//                           Invoice No
//                         </Form.Label>
//                         <Form.Control
//                           type="text"
//                           id="invoicenoInput"
//                           placeholder="Invoice No"
//                           defaultValue="#TN25000355"
//                         />
//                       </Col>
//                       <Col lg={3} sm={6}>
//                         <div>
//                           <Form.Label htmlFor="date-field">Date</Form.Label>
//                           <Flatpickr
//                             className="form-control flatpickr-input"
//                             placeholder="Select Date-time"
//                             options={{
//                               dateFormat: "d M, Y",
//                             }}
//                           />
//                         </div>
//                       </Col>
//                       <Col lg={3} sm={6}>
//                         <Form.Label htmlFor="choices-payment-status">
//                           Payment Status
//                         </Form.Label>
//                         <select
//                           className="form-select"
//                           data-choices
//                           data-choices-search-false
//                           id="choices-payment-status"
//                           required
//                         >
//                           <option value="">Select Payment Status</option>
//                           <option value="Paid">Paid</option>
//                           <option value="Unpaid">Unpaid</option>
//                           <option value="Refund">Refund</option>
//                         </select>
//                       </Col>
//                       <Col lg={3} sm={6}>
//                         <div>
//                           <Form.Label htmlFor="totalamountInput">
//                             Total Amount
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             id="totalamountInput"
//                             placeholder="₹0.00"
//                           />
//                         </div>
//                       </Col>
//                     </Row>
//                   </Card.Body>
//                   <Card.Body className="p-4 border-top border-top-dashed">
//                     <Row>
//                       <Col lg={4} sm={6}>
//                         <div>
//                           <Form.Label
//                             htmlFor="billingName"
//                             className="text-muted text-uppercase fw-semibold"
//                           >
//                             Billing Address
//                           </Form.Label>
//                         </div>
//                         <div className="mb-2">
//                           <Form.Control
//                             type="text"
//                             id="billingName"
//                             placeholder="Full Name"
//                             required
//                           />
//                           <div className="invalid-feedback">
//                             Please enter a full name
//                           </div>
//                         </div>
//                         <div className="mb-2">
//                           <textarea
//                             className="form-control"
//                             id="billingAddress"
//                             placeholder="Address"
//                             defaultValue=""
//                             rows={3}
//                           />
//                           <div className="invalid-feedback">
//                             Please enter a address
//                           </div>
//                         </div>
//                         <div className="mb-2">
//                           <Form.Control
//                             type="number"
//                             data-plugin="cleave-phone"
//                             id="billingPhoneno"
//                             placeholder="(123)456-7890"
//                             required
//                           />
//                           <div className="invalid-feedback">
//                             Please enter a phone number
//                           </div>
//                         </div>
//                         <div className="mb-3">
//                           <Form.Control
//                             type="text"
//                             id="billingTaxno"
//                             placeholder="Tax Number"
//                             required
//                           />
//                           <div className="invalid-feedback">
//                             Please enter a tax number
//                           </div>
//                         </div>
//                         <div className="form-check">
//                           <Form.Check type="checkbox" id="same" name="same" />
//                           <Form.Label
//                             className="form-check-label"
//                             htmlFor="same"
//                           >
//                             Will your Billing and Shipping address same?
//                           </Form.Label>
//                         </div>
//                       </Col>
//                       <Col sm={6} className="ms-auto">
//                         <Row>
//                           <Col lg={8}>
//                             <div>
//                               <Form.Label
//                                 htmlFor="shippingName"
//                                 className="text-muted text-uppercase fw-semibold"
//                               >
//                                 Shipping Address
//                               </Form.Label>
//                             </div>
//                             <div className="mb-2">
//                               <Form.Control
//                                 type="text"
//                                 id="shippingName"
//                                 placeholder="Full Name"
//                                 required
//                               />
//                               <div className="invalid-feedback">
//                                 Please enter full name
//                               </div>
//                             </div>
//                             <div className="mb-2">
//                               <textarea
//                                 className="form-control"
//                                 id="shippingAddress"
//                                 placeholder="Address"
//                                 defaultValue=""
//                                 rows={3}
//                               />
//                               <div className="invalid-feedback">
//                                 Please enter a address
//                               </div>
//                             </div>
//                             <div className="mb-2">
//                               <Form.Control
//                                 type="number"
//                                 data-plugin="cleave-phone"
//                                 id="shippingPhoneno"
//                                 placeholder="(123)456-7890"
//                                 required
//                               />
//                               <div className="invalid-feedback">
//                                 Please enter a phone number
//                               </div>
//                             </div>
//                             <div>
//                               <Form.Control
//                                 type="text"
//                                 id="shippingTaxno"
//                                 placeholder="Tax Number"
//                                 required
//                               />
//                               <div className="invalid-feedback">
//                                 Please enter a tax number
//                               </div>
//                             </div>
//                           </Col>
//                         </Row>
//                       </Col>
//                     </Row>
//                   </Card.Body>
//                   <Card.Body className="p-4">
//                     <div className="table-responsive">
//                       <Table className="invoice-table table-borderless table-nowrap mb-0">
//                         <thead className="align-middle">
//                           <tr className="table-active">
//                             <th scope="col" style={{ width: "50px" }}>
//                               #
//                             </th>
//                             <th scope="col">Product Details</th>
//                             <th scope="col" style={{ width: "120px" }}>
//                               <div className="d-flex currency-select input-light align-items-center">
//                                 Rate
//                                 <Select
//                                   defaultValue={isCurrency}
//                                   onChange={handleisCurrency}
//                                   options={allcurrency}
//                                   id="choices-payment-currency"
//                                   className="form-selectborder-0 bg-light"
//                                 />
//                               </div>
//                             </th>
//                             <th scope="col" style={{ width: "120px" }}>
//                               Quantity
//                             </th>
//                             <th
//                               scope="col"
//                               className="text-end"
//                               style={{ width: "180px" }}
//                             >
//                               Amount
//                             </th>
//                             <th
//                               scope="col"
//                               className="text-end"
//                               style={{ width: "105px" }}
//                             ></th>
//                           </tr>
//                         </thead>
//                         <tbody id="newlink">
//                           <tr id="1" className="product">
//                             <th scope="row" className="product-id">
//                               1
//                             </th>
//                             <td className="text-start">
//                               <div className="mb-2">
//                                 <Form.Control
//                                   type="text"
//                                   id="productName-1"
//                                   placeholder="Product Name"
//                                   required
//                                 />
//                                 <div className="invalid-feedback">
//                                   Please enter a product name
//                                 </div>
//                               </div>
//                               <textarea
//                                 className="form-control"
//                                 id="productDetails-1"
//                                 placeholder="Product Details"
//                                 defaultValue=""
//                               />
//                             </td>
//                             <td>
//                               <Form.Control
//                                 type="number"
//                                 className="product-price"
//                                 id="productRate-1"
//                                 step="0.01"
//                                 placeholder="0.00"
//                                 required
//                               />
//                               <div className="invalid-feedback">
//                                 Please enter a rate
//                               </div>
//                             </td>
//                             <td>
//                               <div className="input-step">
//                                 <Button className="minus">–</Button>
//                                 <input
//                                   type="number"
//                                   className="product-quantity"
//                                   id="product-qty-1"
//                                   defaultValue="0"
//                                 />
//                                 <Button className="plus">+</Button>
//                               </div>
//                             </td>
//                             <td className="text-end">
//                               <div>
//                                 <Form.Control
//                                   type="number"
//                                   className="product-line-price"
//                                   id="productPrice-1"
//                                   placeholder="₹0.00"
//                                 />
//                               </div>
//                             </td>
//                             <td className="product-removal">
//                               <Link to="#" className="btn btn-danger">
//                                 Delete
//                               </Link>
//                             </td>
//                           </tr>
//                         </tbody>
//                         <tbody>
//                           <tr id="newForm" style={{ display: "none" }}>
//                             <td className="d-none">
//                               <p>Add New Form</p>
//                             </td>
//                           </tr>
//                           <tr>
//                             <td>
//                               <Link
//                                 to="#"
//                                 id="add-item"
//                                 className="btn btn-soft-secondary fw-medium"
//                               >
//                                 <i className="ri-add-fill me-1 align-bottom"></i>{" "}
//                                 Add Item
//                               </Link>
//                             </td>
//                           </tr>
//                           <tr className="border-top border-top-dashed mt-2">
//                             <td colSpan={3}></td>
//                             <td className="p-0" colSpan={2}>
//                               <Table className="table-borderless table-sm table-nowrap align-middle mb-0">
//                                 <tbody>
//                                   <tr>
//                                     <th scope="row">Sub Total</th>
//                                     <td style={{ width: "150px" }}>
//                                       <Form.Control
//                                         type="number"
//                                         id="cart-subtotal"
//                                         placeholder="₹0.00"
//                                       />
//                                     </td>
//                                   </tr>
//                                   <tr>
//                                     <th scope="row">Estimated Tax (12.5%)</th>
//                                     <td>
//                                       <Form.Control
//                                         type="number"
//                                         id="cart-tax"
//                                         placeholder="₹0.00"
//                                       />
//                                     </td>
//                                   </tr>
//                                   <tr>
//                                     <th scope="row">
//                                       Discount{" "}
//                                       <small className="text-muted">
//                                         (TONER)
//                                       </small>
//                                     </th>
//                                     <td>
//                                       <Form.Control
//                                         type="number"
//                                         id="cart-discount"
//                                         placeholder="₹0.00"
//                                       />
//                                     </td>
//                                   </tr>
//                                   <tr>
//                                     <th scope="row">Shipping Charge</th>
//                                     <td>
//                                       <Form.Control
//                                         type="number"
//                                         id="cart-shipping"
//                                         placeholder="₹0.00"
//                                       />
//                                     </td>
//                                   </tr>
//                                   <tr className="border-top border-top-dashed">
//                                     <th scope="row">Total Amount</th>
//                                     <td>
//                                       <Form.Control
//                                         type="number"
//                                         id="cart-total"
//                                         placeholder="₹0.00"
//                                       />
//                                     </td>
//                                   </tr>
//                                 </tbody>
//                               </Table>
//                             </td>
//                           </tr>
//                         </tbody>
//                       </Table>
//                     </div>
//                     <Row className="mt-3">
//                       <Col lg={4}>
//                         <div className="mb-2">
//                           <Form.Label
//                             htmlFor="choices-payment-type"
//                             className="text-muted text-uppercase fw-semibold"
//                           >
//                             Payment Details
//                           </Form.Label>
//                           <select
//                             className="form-select"
//                             data-choices
//                             data-choices-search-false
//                             id="choices-payment-type"
//                           >
//                             <option value="">Payment Method</option>
//                             <option value="Mastercard">Mastercard</option>
//                             <option value="Credit Card">Credit Card</option>
//                             <option value="Visa">Visa</option>
//                             <option value="Paypal">Paypal</option>
//                           </select>
//                         </div>
//                         <div className="mb-2">
//                           <Form.Control
//                             type="text"
//                             id="cardholderName"
//                             placeholder="Card Holder Name"
//                           />
//                         </div>
//                         <div className="mb-2">
//                           <Form.Control
//                             type="number"
//                             id="cardNumber"
//                             placeholder="xxxx xxxx xxxx xxxx"
//                           />
//                         </div>
//                         <div>
//                           <Form.Control
//                             type="number"
//                             id="amountTotalPay"
//                             placeholder="₹0.00"
//                           />
//                         </div>
//                       </Col>
//                     </Row>
//                     <div className="mt-4">
//                       <Form.Label
//                         htmlFor="exampleFormControlTextarea1"
//                         className="text-muted text-uppercase fw-semibold"
//                       >
//                         NOTES
//                       </Form.Label>
//                       <textarea
//                         className="form-control alert alert-warning"
//                         id="exampleFormControlTextarea1"
//                         placeholder="Notes"
//                         defaultValue="All accounts are to be paid within 7 days from receipt of invoice. To be paid by cheque or credit card or direct payment online. If account is not paid within 7 days the credits details supplied as confirmation of work undertaken will be charged the agreed quoted fee noted above."
//                       />
//                     </div>
//                     <div className="hstack gap-2 justify-content-end d-print-none mt-4">
//                       <Button variant="success" type="submit">
//                         <i className="ri-printer-line align-bottom me-1"></i>{" "}
//                         Save
//                       </Button>
//                       <Link to="#" className="btn btn-primary">
//                         <i className="ri-download-2-line align-bottom me-1"></i>{" "}
//                         Download Invoice
//                       </Link>
//                       <Link to="#" className="btn btn-danger">
//                         <i className="ri-send-plane-fill align-bottom me-1"></i>{" "}
//                         Send Invoice
//                       </Link>
//                     </div>
//                   </Card.Body>
//                 </Form>
//               </Card>
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </React.Fragment>
//   );
// };

// export default CreateInvoice;

import React, { useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Table,
} from "react-bootstrap";
import Breadcrumb from "Common/BreadCrumb";
import Flatpickr from "react-flatpickr";
import Select, { type SingleValue, type ActionMeta } from "react-select";
import { Link } from "react-router-dom";

// Import Images
import logoDark from "assets/images/anjal-gold-logo.png";
import logoLight from "assets/images/anjal-gold-logo.png";
import {
  fetchOrders,
  generateInvoicePDF,
  saveInvoice,
  sendInvoiceEmail,
} from "api/apis";
import { Address, InvoiceData, InvoiceItem, Order } from "interface";

interface OrdersResponse {
  orders: Order[];
  user: any[]; // You might want to define a proper type for user
  totalPages: number;
  currentPage: number;
  count: number;
}

const CreateInvoice = () => {
  document.title = "Create Invoice";

  const [isCurrency, setisCurrency] = useState("₹");
  const [sameAsBilling, setSameAsBilling] = useState(false);
  const [billingAddress, setBillingAddress] = useState({
    // address: "",
    street: "",
    city: "",
    postalCode: "",
    state: "",
  });
  const [shippingAddress, setShippingAddress] = useState({
    // address: "",
    street: "",
    city: "",
    postalCode: "",
    state: "",
  });
  const [customerInfo, setCustomerInfo] = useState({
    name: "",
    email: "",
  });
  const [items, setItems] = useState([{ id: 1 }]);
  const [isSending, setIsSending] = useState(false);
  const [sendStatus, setSendStatus] = useState<{
    success: boolean;
    message: string;
  } | null>(null);
  const [orderId, setOrderId] = useState<string>("");

  const [orders, setOrders] = useState<OrdersResponse>({
    orders: [],
    user: [],
    totalPages: 1,
    currentPage: 1,
    count: 0,
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    limit: 100,
    totalCount: 0,
  });

  const handleSendInvoice = async (e: React.MouseEvent) => {
    e.preventDefault();
    setIsSending(true);
    setSendStatus(null);

    try {
      // Collect all form data
      const invoiceData: InvoiceData = {
        invoiceNumber: (
          document.getElementById("invoicenoInput") as HTMLInputElement
        ).value,
        date: (document.querySelector(".flatpickr-input") as HTMLInputElement)
          .value,
        paymentStatus: (
          document.getElementById("choices-payment-status") as HTMLSelectElement
        ).value,
        companyName: "Anjal Gold",
        companyAddress: (
          document.getElementById("companyAddress") as HTMLTextAreaElement
        ).value,
        companyPostalCode: (
          document.getElementById("companyaddpostalcode") as HTMLInputElement
        ).value,
        registrationNumber: (
          document.getElementById("registrationNumber") as HTMLInputElement
        ).value,
        companyEmail: (
          document.getElementById("companyEmail") as HTMLInputElement
        ).value,
        companyWebsite: (
          document.getElementById("companyWebsite") as HTMLInputElement
        ).value,
        companyPhone: (
          document.getElementById("compnayContactno") as HTMLInputElement
        ).value,
        clientName: customerInfo.name,
        clientAddress: `${shippingAddress.street}, ${shippingAddress.city}, ${shippingAddress.state} ${shippingAddress.postalCode}`,
        clientEmail: customerInfo.email,
        billingAddress: `${billingAddress.street}, ${billingAddress.city}, ${billingAddress.state} ${billingAddress.postalCode}`,
        shippingAddress: `${shippingAddress.street}, ${shippingAddress.city}, ${shippingAddress.state} ${shippingAddress.postalCode}`,
        items: [],
        subtotal:
          parseFloat(
            (document.getElementById("cart-subtotal") as HTMLInputElement).value
          ) || 0,
        tax:
          parseFloat(
            (document.getElementById("cart-tax") as HTMLInputElement).value
          ) || 0,
        discount:
          parseFloat(
            (document.getElementById("cart-discount") as HTMLInputElement).value
          ) || 0,
        total:
          parseFloat(
            (document.getElementById("cart-total") as HTMLInputElement).value
          ) || 0,
        currency: isCurrency,
        paymentMethod: (
          document.getElementById("choices-payment-type") as HTMLSelectElement
        ).value,
        paymentDetails: (
          document.getElementById("paymentDetails") as HTMLInputElement
        ).value,
        notes: (
          document.getElementById(
            "exampleFormControlTextarea1"
          ) as HTMLTextAreaElement
        ).value,
      };

      // Collect items from the table
      const rows = document.querySelectorAll(".invoice-table tbody tr.product");
      rows.forEach((row) => {
        const item: InvoiceItem = {
          description:
            (row.querySelector(".product-name") as HTMLInputElement)?.value ||
            "",
          details:
            (row.querySelector(".product-details") as HTMLTextAreaElement)
              ?.value || "",
          karat:
            (row.querySelector(".product-karat") as HTMLInputElement)?.value ||
            "",
          weight:
            parseFloat(
              (row.querySelector(".product-weight") as HTMLInputElement)?.value
            ) || 0,
          price:
            parseFloat(
              (row.querySelector(".product-price") as HTMLInputElement)?.value
            ) || 0,
          quantity:
            parseInt(
              (row.querySelector(".product-quantity") as HTMLInputElement)
                ?.value
            ) || 1,
          total:
            parseFloat(
              (row.querySelector(".product-line-price") as HTMLInputElement)
                ?.value
            ) || 0,
        };
        invoiceData.items.push(item);
      });

      // Call the API
      const result = await sendInvoiceEmail({
        invoiceData,
        to: customerInfo.email,
        subject: `Invoice ${invoiceData.invoiceNumber} from Anjal Gold`,
        message: `Please find attached invoice #${invoiceData.invoiceNumber} for your records.`,
      });

      setSendStatus({
        success: true,
        message: `Invoice sent successfully to ${customerInfo.email}`,
      });
    } catch (error) {
      console.error("Error sending invoice:", error);
      setSendStatus({
        success: false,
        message:
          error instanceof Error ? error.message : "Failed to send invoice",
      });
    } finally {
      setIsSending(false);
    }
  };

  const handleDownloadInvoice = async (e: React.MouseEvent) => {
    e.preventDefault();

    try {
      // Collect all form data (same as in handleSendInvoice)
      const invoiceData: InvoiceData = {
        invoiceNumber: (
          document.getElementById("invoicenoInput") as HTMLInputElement
        ).value,
        date: (document.querySelector(".flatpickr-input") as HTMLInputElement)
          .value,
        paymentStatus: (
          document.getElementById("choices-payment-status") as HTMLSelectElement
        ).value,
        companyName: "Anjal Gold",
        companyAddress: (
          document.getElementById("companyAddress") as HTMLTextAreaElement
        ).value,
        companyPostalCode: (
          document.getElementById("companyaddpostalcode") as HTMLInputElement
        ).value,
        registrationNumber: (
          document.getElementById("registrationNumber") as HTMLInputElement
        ).value,
        companyEmail: (
          document.getElementById("companyEmail") as HTMLInputElement
        ).value,
        companyWebsite: (
          document.getElementById("companyWebsite") as HTMLInputElement
        ).value,
        companyPhone: (
          document.getElementById("compnayContactno") as HTMLInputElement
        ).value,
        clientName: customerInfo.name,
        clientAddress: `${shippingAddress.street}, ${shippingAddress.city}, ${shippingAddress.state} ${shippingAddress.postalCode}`,
        clientEmail: customerInfo.email,
        billingAddress: `${billingAddress.street}, ${billingAddress.city}, ${billingAddress.state} ${billingAddress.postalCode}`,
        shippingAddress: `${shippingAddress.street}, ${shippingAddress.city}, ${shippingAddress.state} ${shippingAddress.postalCode}`,
        items: [],
        subtotal:
          parseFloat(
            (document.getElementById("cart-subtotal") as HTMLInputElement).value
          ) || 0,
        tax:
          parseFloat(
            (document.getElementById("cart-tax") as HTMLInputElement).value
          ) || 0,
        discount:
          parseFloat(
            (document.getElementById("cart-discount") as HTMLInputElement).value
          ) || 0,
        total:
          parseFloat(
            (document.getElementById("cart-total") as HTMLInputElement).value
          ) || 0,
        currency: isCurrency,
        paymentMethod: (
          document.getElementById("choices-payment-type") as HTMLSelectElement
        ).value,
        paymentDetails: (
          document.getElementById("paymentDetails") as HTMLInputElement
        ).value,
        notes: (
          document.getElementById(
            "exampleFormControlTextarea1"
          ) as HTMLTextAreaElement
        ).value,
      };

      // Collect items from the table
      const rows = document.querySelectorAll(".invoice-table tbody tr.product");
      rows.forEach((row) => {
        const item: InvoiceItem = {
          description:
            (row.querySelector(".product-name") as HTMLInputElement)?.value ||
            "",
          details:
            (row.querySelector(".product-details") as HTMLTextAreaElement)
              ?.value || "",
          karat:
            (row.querySelector(".product-karat") as HTMLInputElement)?.value ||
            "",
          weight:
            parseFloat(
              (row.querySelector(".product-weight") as HTMLInputElement)?.value
            ) || 0,
          price:
            parseFloat(
              (row.querySelector(".product-price") as HTMLInputElement)?.value
            ) || 0,
          quantity:
            parseInt(
              (row.querySelector(".product-quantity") as HTMLInputElement)
                ?.value
            ) || 1,
          total:
            parseFloat(
              (row.querySelector(".product-line-price") as HTMLInputElement)
                ?.value
            ) || 0,
        };
        invoiceData.items.push(item);
      });

      // Call the PDF generation API
      await generateInvoicePDF(invoiceData);
    } catch (error) {
      console.error("Error generating PDF:", error);
      // You might want to add error handling here (e.g., show a toast notification)
    }
  };

  const handleBillingChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { id, value } = e.target;
    setBillingAddress((prev) => ({
      ...prev,
      [id]: value,
    }));

    // If "Same as billing" is checked, update shipping address too
    if (sameAsBilling) {
      setShippingAddress((prev) => ({
        ...prev,
        [id]: value,
      }));
    }
  };

  const handleSaveInvoice = async (e: React.MouseEvent) => {
    e.preventDefault();

    try {
      // Collect all form data
      const invoiceData = {
        companyInfo: {
          address: (
            document.getElementById("companyAddress") as HTMLTextAreaElement
          ).value,
          postalCode: (
            document.getElementById("companyaddpostalcode") as HTMLInputElement
          ).value,
          registrationNumber: (
            document.getElementById("registrationNumber") as HTMLInputElement
          ).value,
          email: (document.getElementById("companyEmail") as HTMLInputElement)
            .value,
          website: (
            document.getElementById("companyWebsite") as HTMLInputElement
          ).value,
          contactNumber: (
            document.getElementById("compnayContactno") as HTMLInputElement
          ).value,
          // Add logo if available
          logo: logoDark, // or get from your form if you have an input for it
        },
        invoiceNumber: (
          document.getElementById("invoicenoInput") as HTMLInputElement
        ).value,
        date: (document.querySelector(".flatpickr-input") as HTMLInputElement)
          .value,
        paymentStatus: (
          document.getElementById("choices-payment-status") as HTMLSelectElement
        ).value,
        customer: {
          name: customerInfo.name,
          email: customerInfo.email,
        },
        billingAddress: {
          street: billingAddress.street,
          city: billingAddress.city,
          postalCode: billingAddress.postalCode,
          state: billingAddress.state,
        },
        shippingAddress: {
          street: shippingAddress.street,
          city: shippingAddress.city,
          postalCode: shippingAddress.postalCode,
          state: shippingAddress.state,
        },
        sameAsBilling: sameAsBilling,
        items: [] as Array<{
          productName: string;
          productDetails: string;
          karat: string;
          weight: number;
          pricePerGram: number;
          quantity: number;
          totalPrice: number;
        }>,
        subTotal:
          parseFloat(
            (document.getElementById("cart-subtotal") as HTMLInputElement).value
          ) || 0,
        taxes:
          parseFloat(
            (document.getElementById("cart-tax") as HTMLInputElement).value
          ) || 0,
        discounts:
          parseFloat(
            (document.getElementById("cart-discount") as HTMLInputElement).value
          ) || 0,
        finalAmount:
          parseFloat(
            (document.getElementById("cart-total") as HTMLInputElement).value
          ) || 0,
        totalAmount:
          parseFloat(
            (document.getElementById("cart-total") as HTMLInputElement).value
          ) || 0,
        paymentMode: (
          document.getElementById("choices-payment-type") as HTMLSelectElement
        ).value,
        paymentDetails: (
          document.getElementById("paymentDetails") as HTMLInputElement
        ).value,
        notes: (
          document.getElementById(
            "exampleFormControlTextarea1"
          ) as HTMLTextAreaElement
        ).value,
      };

      // Collect items from the table
      const rows = document.querySelectorAll(".invoice-table tbody tr.product");
      rows.forEach((row) => {
        const purityElement = row.querySelector(
          ".product-purity .select__single-value"
        ) as HTMLElement;

        invoiceData.items.push({
          productName:
            (row.querySelector(".product-name") as HTMLInputElement)?.value ||
            "",
          productDetails:
            (row.querySelector(".product-details") as HTMLTextAreaElement)
              ?.value || "",
          karat:
            (row.querySelector(".product-karat") as HTMLInputElement)?.value ||
            "",
          weight:
            parseFloat(
              (row.querySelector(".product-weight") as HTMLInputElement)?.value
            ) || 0,
          pricePerGram:
            parseFloat(
              (row.querySelector(".product-price") as HTMLInputElement)?.value
            ) || 0,
          quantity:
            parseInt(
              (row.querySelector(".product-quantity") as HTMLInputElement)
                ?.value
            ) || 1,
          totalPrice:
            parseFloat(
              (row.querySelector(".product-line-price") as HTMLInputElement)
                ?.value
            ) || 0,
        });
      });

      // Call the save invoice API
      const result = await saveInvoice(invoiceData);

      // Show success message
      setSendStatus({
        success: true,
        message: "Invoice saved successfully",
      });
    } catch (error) {
      console.error("Error saving invoice:", error);
      setSendStatus({
        success: false,
        message:
          error instanceof Error ? error.message : "Failed to save invoice",
      });
    }
  };

  const handleShippingChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { id, value } = e.target;
    setShippingAddress((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleSameAsBillingChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isChecked = e.target.checked;
    setSameAsBilling(isChecked);

    if (isChecked) {
      // Copy billing address to shipping address
      setShippingAddress({ ...billingAddress });
    }
  };

  const handleCustomerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    setCustomerInfo((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const addNewItem = () => {
    const newId =
      items.length > 0 ? Math.max(...items.map((item) => item.id)) + 1 : 1;
    setItems([...items, { id: newId }]);
  };

  const removeItem = (id: number) => {
    setItems(items.filter((item) => item.id !== id));
  };

  const purityOptions = [
    { value: "24K", label: "24K" },
    { value: "22K", label: "22K" },
    { value: "18K", label: "18K" },
    { value: "14K", label: "14K" },
  ];

  const loadOrders = async (page: number = 1) => {
    try {
      setLoading(true);
      setError("");
      const data = await fetchOrders(page, pagination.limit);
      setOrders(data);
      console.log("Data : ", data);
      setPagination({
        ...pagination,
        currentPage: data.currentPage,
        totalPages: data.totalPages,
        totalCount: data.count,
      });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to load orders");
    } finally {
      setLoading(false);
    }
  };

  // const handleOrderSelect = (selectedOrderId: string) => {
  //   const selectedOrder = orders.orders.find(
  //     (order) => order._id === selectedOrderId
  //   );
  //   if (!selectedOrder || !selectedOrder.user) {
  //     console.error("Order or user not found");
  //     return;
  //   }

  //   // Set customer information
  //   setCustomerInfo({
  //     name: `${selectedOrder.user.firstName || ""} ${
  //       selectedOrder.user.lastName || ""
  //     }`.trim(),
  //     email: selectedOrder.user.email || "",
  //   });

  //   // Set order totals
  //   const totalInput = document.getElementById(
  //     "totalamountInput"
  //   ) as HTMLInputElement;
  //   if (totalInput) {
  //     totalInput.value = selectedOrder.totalWithTax?.toString() || "0";
  //   }

  //   const cartTotal = document.getElementById("cart-total") as HTMLInputElement;
  //   if (cartTotal) {
  //     cartTotal.value = selectedOrder.totalWithTax.toString();
  //   }

  //   const cartSubtotal = document.getElementById(
  //     "cart-subtotal"
  //   ) as HTMLInputElement;
  //   if (cartSubtotal) {
  //     cartSubtotal.value = selectedOrder.total.toString();
  //   }

  //   const cartTax = document.getElementById("cart-tax") as HTMLInputElement;
  //   if (cartTax) {
  //     cartTax.value = selectedOrder.totalTax.toString();
  //   }

  //   // Clear existing items and add new ones from the order
  //   setItems([]);

  //   // Add products from the order
  //   selectedOrder.products.forEach((productItem, index) => {
  //     const newId = index + 1;
  //     setItems((prevItems) => [...prevItems, { id: newId }]);

  //     // Use setTimeout to ensure DOM is updated before setting values
  //     setTimeout(() => {
  //       const product = productItem.product;

  //       // Set product name
  //       const productNameInput = document.querySelector(
  //         `#productName-${newId}`
  //       ) as HTMLInputElement;
  //       if (productNameInput) {
  //         productNameInput.value = product.name;
  //       }

  //       // Set product details
  //       const productDetailsTextarea = document.querySelector(
  //         `#productDetails-${newId}`
  //       ) as HTMLTextAreaElement;
  //       if (productDetailsTextarea) {
  //         productDetailsTextarea.value = product.description || "";
  //       }

  //       // Set purity (karat) as text instead of select
  //       // Set karat as text instead of select
  //       const productKaratInput = document.querySelector(
  //         `#productKarat-${newId}`
  //       ) as HTMLInputElement;
  //       if (productKaratInput) {
  //         productKaratInput.value = product.karat || "22K"; // Use karat instead of purity
  //       }

  //       // Set weight
  //       const productWeightInput = document.querySelector(
  //         `#productWeight-${newId}`
  //       ) as HTMLInputElement;
  //       if (productWeightInput) {
  //         productWeightInput.value = product.weightInGrams.toString();
  //       }

  //       // Set price per gram (calculate from total price)
  //       const pricePerGram = productItem.purchasePrice / product.weightInGrams;
  //       const productPriceInput = document.querySelector(
  //         `#productRate-${newId}`
  //       ) as HTMLInputElement;
  //       if (productPriceInput) {
  //         productPriceInput.value = pricePerGram.toString();
  //       }

  //       // Set quantity
  //       const productQtyInput = document.querySelector(
  //         `#product-qty-${newId}`
  //       ) as HTMLInputElement;
  //       if (productQtyInput) {
  //         productQtyInput.value = productItem.quantity.toString();
  //       }

  //       // Set line price
  //       const productLinePrice = document.querySelector(
  //         `#productPrice-${newId}`
  //       ) as HTMLInputElement;
  //       if (productLinePrice) {
  //         productLinePrice.value = productItem.totalPrice.toString();
  //       }
  //     }, 100);
  //   });
  // };

  // Update the handleOrderSelect function to include address details

const handleOrderSelect = (selectedOrderId: string) => {
  const selectedOrder = orders.orders.find(
    (order) => order._id === selectedOrderId
  );

  if (!selectedOrder) {
    console.error("Order not found");
    return;
  }

  // Helper function to safely access address properties
  // const getAddressField = (field: keyof Address): string => {
  //   if (typeof selectedOrder.address === 'string') {
  //     return '';
  //   }
  //   return selectedOrder.address?.[field]?.toString() || '';
  // };

  // Set customer information
  setCustomerInfo({
    name: typeof selectedOrder.address === 'string' 
      ? selectedOrder.customerName || `${selectedOrder.firstName || ''} ${selectedOrder.lastName || ''}`.trim()
      : `${selectedOrder.address?.firstName || ''} ${selectedOrder.address?.lastName || ''}`.trim(),
    email: selectedOrder.user?.email || '',
  });

  // Set address information
  setBillingAddress({
    street: typeof selectedOrder.address === 'string' 
      ? selectedOrder.address 
      : selectedOrder.address?.address || '',
    city: typeof selectedOrder.address === 'string' 
      ? selectedOrder.city || ''
      : selectedOrder.address?.city || '',
    postalCode: typeof selectedOrder.address === 'string' 
      ? '' 
      : selectedOrder.address?.postalCode || '',
    state: typeof selectedOrder.address === 'string' 
      ? selectedOrder.country || ''
      : selectedOrder.address?.state || '',
  });

  setShippingAddress({
    street: typeof selectedOrder.address === 'string' 
      ? selectedOrder.address 
      : selectedOrder.address?.address || '',
    city: typeof selectedOrder.address === 'string' 
      ? selectedOrder.city || ''
      : selectedOrder.address?.city || '',
    postalCode: typeof selectedOrder.address === 'string' 
      ? '' 
      : selectedOrder.address?.postalCode || '',
    state: typeof selectedOrder.address === 'string' 
      ? selectedOrder.country || ''
      : selectedOrder.address?.state || '',
  });

  // Set order totals
  const totalInput = document.getElementById("totalamountInput") as HTMLInputElement;
  if (totalInput) {
    totalInput.value = selectedOrder.totalWithTax?.toString() || selectedOrder.total?.toString() || "0";
  }

  const cartTotal = document.getElementById("cart-total") as HTMLInputElement;
  if (cartTotal) {
    if (selectedOrder.chargesBreakdown?.finalTotal) {
      cartTotal.value = selectedOrder.chargesBreakdown.finalTotal.toString();
    } else {
      cartTotal.value = selectedOrder.totalWithTax?.toString() || selectedOrder.total?.toString() || "0";
    }
  }

  const cartSubtotal = document.getElementById("cart-subtotal") as HTMLInputElement;
  if (cartSubtotal) {
    if (selectedOrder.chargesBreakdown?.subtotal) {
      cartSubtotal.value = selectedOrder.chargesBreakdown.subtotal.toString();
    } else {
      cartSubtotal.value = selectedOrder.total?.toString() || "0";
    }
  }

  const cartTax = document.getElementById("cart-tax") as HTMLInputElement;
  if (cartTax) {
    if (selectedOrder.chargesBreakdown?.charges?.tax?.amount) {
      cartTax.value = selectedOrder.chargesBreakdown.charges.tax.amount.toString();
    } else if (selectedOrder.totalTax) {
      cartTax.value = selectedOrder.totalTax.toString();
    }
  }

  const cartDiscount = document.getElementById("cart-discount") as HTMLInputElement;
  if (cartDiscount) {
    if (selectedOrder.chargesBreakdown?.discount) {
      cartDiscount.value = selectedOrder.chargesBreakdown.discount.toString();
    } else if (selectedOrder.coupon?.discountAmount) {
      cartDiscount.value = selectedOrder.coupon.discountAmount.toString();
    } else {
      cartDiscount.value = "0";
    }
  }

  // Clear existing items and add new ones from the order
  setItems([]);

  // Add products from the order
  selectedOrder.products.forEach((productItem, index) => {
    const newId = index + 1;
    setItems((prevItems) => [...prevItems, { id: newId }]);

    // Use setTimeout to ensure DOM is updated before setting values
    setTimeout(() => {
      const product = productItem.product;
      const variant = product.variants?.[0];

      // Set product name
      const productNameInput = document.querySelector(
        `#productName-${newId}`
      ) as HTMLInputElement;
      if (productNameInput) {
        productNameInput.value = product.name;
      }

      // Set product details
      const productDetailsTextarea = document.querySelector(
        `#productDetails-${newId}`
      ) as HTMLTextAreaElement;
      if (productDetailsTextarea && variant?.attributes) {
        const details = variant.attributes.map(attr => 
          `${attr.label}: ${attr.value}${attr.valueType === 'percentage' ? '%' : ''}`
        ).join(', ');
        productDetailsTextarea.value = details;
      }

      // Set karat from attributes
      const productKaratInput = document.querySelector(
        `#productKarat-${newId}`
      ) as HTMLInputElement;
      if (productKaratInput && variant?.attributes) {
        const karatAttr = variant.attributes.find(attr => attr.label === 'Karat');
        productKaratInput.value = karatAttr?.value.toString() || "";
      }

      // Set weight
      const productWeightInput = document.querySelector(
        `#productWeight-${newId}`
      ) as HTMLInputElement;
      if (productWeightInput && variant?.weightInGrams) {
        productWeightInput.value = variant.weightInGrams.toString();
      }

      // Set price per gram (calculate from purchase price and weight)
      const productPriceInput = document.querySelector(
        `#productRate-${newId}`
      ) as HTMLInputElement;
      if (productPriceInput && variant?.weightInGrams) {
        const pricePerGram = productItem.purchasePrice / variant.weightInGrams;
        productPriceInput.value = pricePerGram.toFixed(2);
      }

      // Set quantity
      const productQtyInput = document.querySelector(
        `#product-qty-${newId}`
      ) as HTMLInputElement;
      if (productQtyInput) {
        productQtyInput.value = productItem.quantity.toString();
      }

      // Set line price (total price for this line item)
      const productLinePrice = document.querySelector(
        `#productPrice-${newId}`
      ) as HTMLInputElement;
      if (productLinePrice) {
        productLinePrice.value = (productItem.purchasePrice * productItem.quantity).toString();
      }
    }, 100);
  });
};
  const clearForm = () => {
    setCustomerInfo({ name: "", email: "" });
    setBillingAddress({
      street: "",
      city: "",
      postalCode: "",
      state: "",
      // address: "",
    });
    setShippingAddress({
      street: "",
      city: "",
      postalCode: "",
      state: "",
      // address: "",
    });
    setSameAsBilling(false);
    setItems([{ id: 1 }]);
    setOrderId("");

    // Clear other form fields
    const form = document.getElementById("invoice_form") as HTMLFormElement;
    if (form) {
      form.reset();
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb title="Create Invoice" pageTitle="Invoices" />

          <Row className="justify-content-center">
            <Col xxl={9}>
              <Card>
                <Form className="needs-validation" id="invoice_form">
                  <Card.Body className="border-bottom border-bottom-dashed p-4">
                    <Row>
                      <Col lg={4}>
                        <div className="profile-user mx-auto  mb-3">
                          <input
                            id="profile-img-file-input"
                            type="file"
                            className="profile-img-file-input"
                          />
                          <label
                            htmlFor="profile-img-file-input"
                            className="d-block"
                          >
                            <span
                              className="overflow-hidden border border-dashed d-flex align-items-center justify-content-center rounded"
                              style={{ height: "150px", width: "256px" }}
                            >
                              <img
                                src={logoDark}
                                className="card-logo card-logo-dark user-profile-image img-fluid"
                                alt="logo dark"
                              />
                              <img
                                src={logoLight}
                                className="card-logo card-logo-light user-profile-image img-fluid"
                                alt="logo light"
                              />
                            </span>
                          </label>
                        </div>
                        <div>
                          <div>
                            <Form.Label
                              htmlFor="companyAddress"
                              className="form-label"
                            >
                              Address
                            </Form.Label>
                          </div>
                          <div className="mb-2">
                            <textarea
                              className="form-control"
                              id="companyAddress"
                              placeholder="Company Address"
                              defaultValue=""
                              rows={3}
                            />
                            <div className="invalid-feedback">
                              Please enter a address
                            </div>
                          </div>
                          <div className="mb-2 mb-lg-0">
                            <Form.Control
                              type="text"
                              id="companyaddpostalcode"
                              placeholder="Enter Postal Code"
                              required
                            />
                            <div className="invalid-feedback">
                              The US zip code must contain 5 digits, Ex. 45678
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col lg={4} className="ms-auto">
                        <div className="mb-2">
                          <Form.Control
                            type="text"
                            id="registrationNumber"
                            placeholder="Legal Registration No"
                            required
                          />
                          <div className="invalid-feedback">
                            Please enter a registration no, Ex., 012345678912
                          </div>
                        </div>
                        <div className="mb-2">
                          <Form.Control
                            type="email"
                            id="companyEmail"
                            placeholder="Email Address"
                            required
                          />
                          <div className="invalid-feedback">
                            Please enter a valid email, Ex., example@gamil.com
                          </div>
                        </div>
                        <div className="mb-2">
                          <Form.Control
                            type="text"
                            id="companyWebsite"
                            placeholder="Website"
                            required
                          />
                          <div className="invalid-feedback">
                            Please enter a website, Ex., www.example.com
                          </div>
                        </div>
                        <div>
                          <Form.Control
                            type="number"
                            data-plugin="cleave-phone"
                            id="compnayContactno"
                            placeholder="Contact No"
                            required
                          />
                          <div className="invalid-feedback">
                            Please enter a contact number
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>

                  <Card.Body className="p-4">
                    <Row className="g-3">
                      <Col lg={3} sm={6}>
                        <Form.Label htmlFor="invoicenoInput">
                          Invoice No
                        </Form.Label>
                        <Form.Control
                          type="text"
                          id="invoicenoInput"
                          placeholder="Invoice No"
                          defaultValue="#TN25000355"
                        />
                      </Col>
                      <Col lg={3} sm={6}>
                        <div>
                          <Form.Label htmlFor="date-field">Date</Form.Label>
                          <Flatpickr
                            className="form-control flatpickr-input"
                            placeholder="Select Date-time"
                            options={{
                              dateFormat: "d M, Y",
                            }}
                          />
                        </div>
                      </Col>
                      <Col lg={3} sm={6}>
                        <Form.Label htmlFor="choices-payment-status">
                          Payment Status
                        </Form.Label>
                        <select
                          className="form-select"
                          data-choices
                          data-choices-search-false
                          id="choices-payment-status"
                          required
                        >
                          <option value="">Select Payment Status</option>
                          <option value="Paid">Paid</option>
                          <option value="Unpaid">Unpaid</option>
                          <option value="Refund">Refund</option>
                        </select>
                      </Col>
                      <Col lg={3} sm={6}>
                        <div>
                          <Form.Label htmlFor="totalamountInput">
                            Total Amount
                          </Form.Label>
                          <Form.Control
                            type="number"
                            id="totalamountInput"
                            placeholder="₹0.00"
                          />
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>

                  {/* Customer Information Section */}
                  <Card.Body className="p-4 border-top border-top-dashed">
                    <Row>
                      <Col lg={6}>
                        <h5 className="text-muted text-uppercase fw-semibold mb-3">
                          Customer Information
                        </h5>
                        <div className="mb-3">
                          <Form.Label htmlFor="name">Full Name</Form.Label>
                          <Form.Control
                            type="text"
                            id="name"
                            placeholder="Customer Name"
                            required
                            value={customerInfo.name}
                            onChange={handleCustomerChange}
                          />
                        </div>
                        <div className="mb-3">
                          <Form.Label htmlFor="email">Email Address</Form.Label>
                          <Form.Control
                            type="email"
                            id="email"
                            placeholder="customer@example.com"
                            required
                            value={customerInfo.email}
                            onChange={handleCustomerChange}
                          />
                        </div>
                      </Col>

                      {/* New Column for Order Information */}
                      <Col lg={6}>
                        <h5 className="text-muted text-uppercase fw-semibold mb-3">
                          Order Information
                        </h5>
                        <div className="mb-3">
                          <Form.Label htmlFor="orderId">Order ID</Form.Label>
                          <div className="d-flex gap-2">
                            <Form.Control
                              type="text"
                              id="orderId"
                              placeholder="Select or enter Order ID"
                              value={orderId}
                              onChange={(e) => setOrderId(e.target.value)}
                            />
                            <Button
                              variant="primary"
                              onClick={() => loadOrders(1)}
                              disabled={loading}
                            >
                              {loading ? "Loading..." : "Load Orders"}
                            </Button>
                          </div>

                          {orders.orders.length > 0 && (
                            <div className="mt-2">
                              <Select
                                options={orders.orders.map((order) => ({
                                  value: order._id,
                                  label: `${order._id} / ${
                                    order.user?.firstName || "N/A"
                                  } ${order.user?.lastName || ""}`,
                                }))}
                                value={
                                  orderId
                                    ? {
                                        value: orderId,
                                        label: `${orderId} / ${
                                          orders.orders.find(
                                            (order) => order._id === orderId
                                          )?.user?.firstName || "N/A"
                                        } ${
                                          orders.orders.find(
                                            (order) => order._id === orderId
                                          )?.user?.lastName || ""
                                        }`,
                                      }
                                    : null
                                }
                                onChange={(selected) => {
                                  if (selected) {
                                    setOrderId(selected.value);
                                    handleOrderSelect(selected.value);
                                  } else {
                                    setOrderId("");
                                  }
                                }}
                                placeholder="Select/Search an Order ID"
                                styles={{
                                  menuList: (base) => ({
                                    ...base,
                                    maxHeight: "300px",
                                  }),
                                }}
                              />
                            </div>
                          )}

                          {error && (
                            <div className="text-danger mt-2">{error}</div>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>

                  <Card.Body className="p-4 border-top border-top-dashed">
                    <Row>
                      <Col lg={6}>
                        <div>
                          <Form.Label className="text-muted text-uppercase fw-semibold mb-3">
                            Billing Address
                          </Form.Label>
                        </div>
                        <div className="mb-3">
                          <Form.Control
                            as="textarea"
                            id="billingStreet"
                            placeholder="Street Address"
                            rows={3}
                            required
                            value={billingAddress.street}
                            onChange={(e) => {
                              setBillingAddress((prev) => ({
                                ...prev,
                                street: e.target.value,
                              }));
                              if (sameAsBilling) {
                                setShippingAddress((prev) => ({
                                  ...prev,
                                  street: e.target.value,
                                }));
                              }
                            }}
                          />
                          <div className="invalid-feedback">
                            Please enter street address
                          </div>
                        </div>
                        <Row>
                          <Col md={6}>
                            <div className="mb-3">
                              <Form.Control
                                type="text"
                                id="billingCity"
                                placeholder="City"
                                required
                                value={billingAddress.city}
                                onChange={(e) => {
                                  setBillingAddress((prev) => ({
                                    ...prev,
                                    city: e.target.value,
                                  }));
                                  if (sameAsBilling) {
                                    setShippingAddress((prev) => ({
                                      ...prev,
                                      city: e.target.value,
                                    }));
                                  }
                                }}
                              />
                              <div className="invalid-feedback">
                                Please enter city
                              </div>
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="mb-3">
                              <Form.Control
                                type="text"
                                id="billingPostalCode"
                                placeholder="Postal Code"
                                required
                                value={billingAddress.postalCode}
                                onChange={(e) => {
                                  setBillingAddress((prev) => ({
                                    ...prev,
                                    postalCode: e.target.value,
                                  }));
                                  if (sameAsBilling) {
                                    setShippingAddress((prev) => ({
                                      ...prev,
                                      postalCode: e.target.value,
                                    }));
                                  }
                                }}
                              />
                              <div className="invalid-feedback">
                                Please enter postal code
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <div className="mb-3">
                          <Form.Control
                            type="text"
                            id="billingState"
                            placeholder="State/Province"
                            required
                            value={billingAddress.state}
                            onChange={(e) => {
                              setBillingAddress((prev) => ({
                                ...prev,
                                state: e.target.value,
                              }));
                              if (sameAsBilling) {
                                setShippingAddress((prev) => ({
                                  ...prev,
                                  state: e.target.value,
                                }));
                              }
                            }}
                          />
                          <div className="invalid-feedback">
                            Please enter state/province
                          </div>
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <Form.Label className="text-muted text-uppercase fw-semibold">
                            Shipping Address
                          </Form.Label>
                          <Form.Check
                            type="checkbox"
                            id="sameAsBilling"
                            label="Same as billing address"
                            checked={sameAsBilling}
                            onChange={(e) => {
                              const isChecked = e.target.checked;
                              setSameAsBilling(isChecked);
                              if (isChecked) {
                                setShippingAddress({ ...billingAddress });
                              }
                            }}
                          />
                        </div>
                        <div className="mb-3">
                          <Form.Control
                            as="textarea"
                            id="shippingStreet"
                            placeholder="Street Address"
                            rows={3}
                            required
                            value={shippingAddress.street}
                            onChange={(e) =>
                              !sameAsBilling &&
                              setShippingAddress((prev) => ({
                                ...prev,
                                street: e.target.value,
                              }))
                            }
                            disabled={sameAsBilling}
                          />
                          <div className="invalid-feedback">
                            Please enter street address
                          </div>
                        </div>
                        <Row>
                          <Col md={6}>
                            <div className="mb-3">
                              <Form.Control
                                type="text"
                                id="shippingCity"
                                placeholder="City"
                                required
                                value={shippingAddress.city}
                                onChange={(e) =>
                                  !sameAsBilling &&
                                  setShippingAddress((prev) => ({
                                    ...prev,
                                    city: e.target.value,
                                  }))
                                }
                                disabled={sameAsBilling}
                              />
                              <div className="invalid-feedback">
                                Please enter city
                              </div>
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="mb-3">
                              <Form.Control
                                type="text"
                                id="shippingPostalCode"
                                placeholder="Postal Code"
                                required
                                value={shippingAddress.postalCode}
                                onChange={(e) =>
                                  !sameAsBilling &&
                                  setShippingAddress((prev) => ({
                                    ...prev,
                                    postalCode: e.target.value,
                                  }))
                                }
                                disabled={sameAsBilling}
                              />
                              <div className="invalid-feedback">
                                Please enter postal code
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <div className="mb-3">
                          <Form.Control
                            type="text"
                            id="shippingState"
                            placeholder="State/Province"
                            required
                            value={shippingAddress.state}
                            onChange={(e) =>
                              !sameAsBilling &&
                              setShippingAddress((prev) => ({
                                ...prev,
                                state: e.target.value,
                              }))
                            }
                            disabled={sameAsBilling}
                          />
                          <div className="invalid-feedback">
                            Please enter state/province
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>

                  <Card.Body className="p-4">
                    <div className="table-responsive">
                      <Table className="invoice-table table-borderless table-nowrap mb-0">
                        <thead className="align-middle">
                          <tr className="table-active">
                            <th scope="col" style={{ width: "50px" }}>
                              #
                            </th>
                            <th scope="col">Product Details</th>
                            <th scope="col" style={{ width: "120px" }}>
                              Karat
                            </th>
                            <th scope="col" style={{ width: "120px" }}>
                              Weight (grams)
                            </th>
                            <th scope="col" style={{ width: "120px" }}>
                              <div className="d-flex currency-select input-light align-items-center">
                                Price per gram
                              </div>
                            </th>
                            <th scope="col" style={{ width: "120px" }}>
                              Quantity
                            </th>
                            <th
                              scope="col"
                              className="text-end"
                              style={{ width: "180px" }}
                            >
                              Total Price
                            </th>
                            <th
                              scope="col"
                              className="text-end"
                              style={{ width: "105px" }}
                            ></th>
                          </tr>
                        </thead>
                        <tbody id="newlink">
                          {items.map((item, index) => (
                            <tr
                              key={item.id}
                              id={item.id.toString()}
                              className="product"
                            >
                              <th scope="row" className="product-id">
                                {index + 1}
                              </th>
                              <td className="text-start">
                                <div className="mb-2">
                                  <Form.Control
                                    type="text"
                                    id={`productName-${item.id}`}
                                    placeholder="Product Name"
                                    className="product-name"
                                    required
                                  />
                                  <div className="invalid-feedback">
                                    Please enter a product name
                                  </div>
                                </div>
                                <textarea
                                  className="form-control product-details"
                                  id={`productDetails-${item.id}`}
                                  placeholder="Product Details"
                                  defaultValue=""
                                />
                              </td>
                              <td>
                                <Form.Control
                                  type="text"
                                  className="product-karat" // Changed from product-purity
                                  id={`productKarat-${item.id}`} // Changed from productPurity
                                  placeholder="22K"
                                  readOnly
                                />
                              </td>
                              <td>
                                <Form.Control
                                  type="number"
                                  className="product-weight"
                                  id={`productWeight-${item.id}`}
                                  step="0.01"
                                  placeholder="0.00"
                                  required
                                />
                                <div className="invalid-feedback">
                                  Please enter weight in grams
                                </div>
                              </td>
                              <td>
                                <Form.Control
                                  type="number"
                                  className="product-price"
                                  id={`productRate-${item.id}`}
                                  step="0.01"
                                  placeholder="0.00"
                                  required
                                />
                                <div className="invalid-feedback">
                                  Please enter a rate
                                </div>
                              </td>
                              <td>
                                <div className="input-step">
                                  <Button className="minus">–</Button>
                                  <input
                                    type="number"
                                    className="product-quantity"
                                    id={`product-qty-${item.id}`}
                                    defaultValue="1"
                                    min="1"
                                  />
                                  <Button className="plus">+</Button>
                                </div>
                              </td>
                              <td className="text-end">
                                <div>
                                  <Form.Control
                                    type="number"
                                    className="product-line-price"
                                    id={`productPrice-${item.id}`}
                                    placeholder="₹0.00"
                                  />
                                </div>
                              </td>
                              <td className="product-removal">
                                <Button
                                  variant="danger"
                                  onClick={() => removeItem(item.id)}
                                  disabled={items.length <= 1}
                                >
                                  Delete
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        <tbody>
                          <tr>
                            <td colSpan={8}>
                              <Button
                                variant="soft-secondary"
                                className="fw-medium"
                                onClick={addNewItem}
                              >
                                <i className="ri-add-fill me-1 align-bottom"></i>{" "}
                                Add Item
                              </Button>
                            </td>
                          </tr>
                          <tr className="border-top border-top-dashed mt-2">
                            <td colSpan={3}></td>
                            <td className="p-0" colSpan={4}>
                              <Table className="table-borderless table-sm table-nowrap align-middle mb-0">
                                <tbody>
                                  <tr>
                                    <th scope="row">Sub Total</th>
                                    <td style={{ width: "150px" }}>
                                      <Form.Control
                                        type="number"
                                        id="cart-subtotal"
                                        placeholder="₹0.00"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Taxes (if applicable)</th>
                                    <td>
                                      <Form.Control
                                        type="number"
                                        id="cart-tax"
                                        placeholder="₹0.00"
                                      />
                                    </td>
                                  </tr>
                                  <tr>
                                    <th scope="row">Discounts (if any)</th>
                                    <td>
                                      <Form.Control
                                        type="number"
                                        id="cart-discount"
                                        placeholder="₹0.00"
                                      />
                                    </td>
                                  </tr>
                                  <tr className="border-top border-top-dashed">
                                    <th scope="row">Final Amount</th>
                                    <td>
                                      <Form.Control
                                        type="number"
                                        id="cart-total"
                                        placeholder="₹0.00"
                                      />
                                    </td>
                                  </tr>
                                </tbody>
                              </Table>
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                    <Row className="mt-3">
                      <Col lg={4}>
                        <div className="mb-2">
                          <Form.Label
                            htmlFor="choices-payment-type"
                            className="text-muted text-uppercase fw-semibold"
                          >
                            Payment Mode
                          </Form.Label>
                          <select
                            className="form-select"
                            data-choices
                            data-choices-search-false
                            id="choices-payment-type"
                          >
                            <option value="">Payment Method</option>
                            <option value="Cash">Cash</option>
                            <option value="Cheque">Cheque</option>
                            <option value="Credit Card">Credit Card</option>
                            <option value="Bank Transfer">Bank Transfer</option>
                            <option value="UPI">UPI</option>
                          </select>
                        </div>
                        <div className="mb-2">
                          <Form.Control
                            type="text"
                            id="paymentDetails"
                            placeholder="Payment Details (e.g. UPI ID, Cheque No)"
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="mt-4">
                      <Form.Label
                        htmlFor="exampleFormControlTextarea1"
                        className="text-muted text-uppercase fw-semibold"
                      >
                        NOTES
                      </Form.Label>
                      <textarea
                        className="form-control alert alert-warning"
                        id="exampleFormControlTextarea1"
                        placeholder="Notes"
                        defaultValue="All gold items are hallmarked as per government regulations. Goods once sold will not be taken back or exchanged. Please check the items and bill thoroughly at the time of purchase."
                      />
                    </div>
                    <div className="hstack gap-2 justify-content-end d-print-none mt-4">
                      <Button
                        variant="success"
                        type="submit"
                        onClick={handleSaveInvoice}
                      >
                        <i className="ri-printer-line align-bottom me-1"></i>{" "}
                        Save Invoice
                      </Button>
                      <Button variant="primary" onClick={handleDownloadInvoice}>
                        <i className="ri-download-2-line align-bottom me-1"></i>{" "}
                        Download Invoice
                      </Button>
                      <Button
                        variant="danger"
                        onClick={handleSendInvoice}
                        disabled={isSending || !customerInfo.email}
                      >
                        {isSending ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-1"></span>
                            Sending...
                          </>
                        ) : (
                          <>
                            <i className="ri-send-plane-fill align-bottom me-1"></i>
                            Send Invoice
                          </>
                        )}
                      </Button>
                      <Button variant="secondary" onClick={clearForm}>
                        <i className="ri-close-line align-bottom me-1"></i>{" "}
                        Clear Form
                      </Button>
                      {sendStatus && (
                        <div
                          className={`alert alert-${
                            sendStatus.success ? "success" : "danger"
                          } mt-3`}
                        >
                          {sendStatus.message}
                        </div>
                      )}
                    </div>
                  </Card.Body>
                </Form>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CreateInvoice;
